import { createAction } from "@reduxjs/toolkit";
import type {
	ArchiveOrganizationRadioChannelRequest,
	ArchiveOrganizationRadioChannelResponse,
	CreateOrganizationRadioChannelResponse,
	GetOrganizationRadioChannelsResponse,
	OrganizationRadioChannel,
	UpdateOrganizationRadioChannel,
} from "@somewear/api";
import { createActionSet } from "@somewear/model";
import { OrganizationRadioChannelRequest } from "@somewear/radio";

export const emitOrganizationRadioChannelReceived = createAction<OrganizationRadioChannel.AsObject>(
	"emitOrganizationRadioChannelReceived",
);

export const emitOrganizationRadioChannelUpdated =
	createAction<UpdateOrganizationRadioChannel.AsObject>("emitOrganizationRadioChannelUpdated");

export const organizationRadioChannelActions = {
	getRadioChannels: createActionSet<void, GetOrganizationRadioChannelsResponse.AsObject>(
		"organization/radioChannels/get",
	),
	createRadioChannel: createActionSet<
		OrganizationRadioChannelRequest,
		CreateOrganizationRadioChannelResponse.AsObject
	>("organization/radioChannels/create"),
	archiveRadioChannel: createActionSet<
		ArchiveOrganizationRadioChannelRequest.AsObject,
		ArchiveOrganizationRadioChannelResponse.AsObject
	>("organization/radioChannels/archive"),
};
